import css from './AdminLinks.module.css';
import { PiUsersFill } from 'react-icons/pi';
import { TbApiApp } from 'react-icons/tb';
import { HiUserGroup } from 'react-icons/hi';
import { FaUserPlus } from 'react-icons/fa';
import { VscOutput } from 'react-icons/vsc';
import { IoSettingsSharp } from 'react-icons/io5';
import { useState, useEffect } from 'react';

interface AdminLinksProps {
  selectedKey: string;
  onSelect: (key: string) => void;
}

const AdminLinks = ({ selectedKey, onSelect }: AdminLinksProps) => {
  const [showUserSubMenu, setShowUserSubMenu] = useState(false);

  useEffect(() => {
    // Show submenu when User Management or any of its subitems are selected
    setShowUserSubMenu(selectedKey.startsWith('0'));
  }, [selectedKey]);

  const mainMenuItems = [
    {
      key: '0',
      icon: <PiUsersFill />,
      label: 'User Management',
    },
    {
      key: '1',
      icon: <VscOutput />,
      label: 'Log Viewer',
    },
    {
      key: '2',
      icon: <IoSettingsSharp />,
      label: 'Configuration',
    },
  ];

  const userSubMenuItems = [
    {
      key: '0-1',
      icon: <PiUsersFill />,
      label: 'Users',
    },
    {
      key: '0-2',
      icon: <TbApiApp />,
      label: 'API Keys',
    },
    {
      key: '0-3',
      icon: <HiUserGroup />,
      label: 'Awaiting Approval',
    },
    {
      key: '0-4',
      icon: <FaUserPlus />,
      label: 'Awaiting Creation',
    },
  ];

  return (
    <div className={css.menuWrapper}>
      <div className={css.menuContainer}>
        {mainMenuItems.map((item) => (
          <button
            key={item.key}
            className={`${css.menuItem} ${selectedKey.startsWith(item.key) ? css.selected : ''}`}
            onClick={() => {
              if (item.key === '0' && !showUserSubMenu) {
                setShowUserSubMenu(true);
                onSelect('0-1'); // Select the first submenu item by default
              } else {
                onSelect(item.key);
              }
            }}
          >
            <span className={css.icon}>{item.icon}</span>
            <span className={css.label}>{item.label}</span>
          </button>
        ))}
      </div>
      {showUserSubMenu && (
        <div className={`${css.menuContainer} ${css.subMenu}`}>
          {userSubMenuItems.map((item) => (
            <button
              key={item.key}
              className={`${css.menuItem} ${selectedKey === item.key ? css.selected : ''}`}
              onClick={() => onSelect(item.key)}
            >
              <span className={css.icon}>{item.icon}</span>
              <span className={css.label}>{item.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminLinks;
